module.exports = __webpack_public_path__ + "static/media/x.058a90db.svg";